import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-alert-wizard',
    templateUrl: './alert-wizard.component.html',
    styleUrls: ['./alert-wizard.component.scss'],
    standalone: false
})
export class AlertWizardComponent implements OnInit {

  alertWizardTitle:string;
  titelFontColor:string;
  bodyMessageColor:string;
  alertWizardBodyMessage:string;
  alertWizardBodyMessage2:string='';
  alertWizardBodyMessage2List: Array<{ label: string; value: string | number }> = [];
  alertIcon:string='';
  cancelButtonText:string;
  confirmButtonText:string;
  cancelButtonColor:string;
  confirmButtonColor:string;
  buttonglobalClass :string;
  isButtonOneDisabled :boolean;
  isButtonTwoDisabled :boolean;
  constructor(
    public dialogRef: MatDialogRef<AlertWizardComponent>,  
    public dialog: MatDialog,
    @Optional() @Inject(MAT_DIALOG_DATA) public data:any) { 
      this.alertIcon = data.alertIcon;
      this.alertWizardTitle = data.title;
      this.alertWizardBodyMessage = data.bodyMessage;
      this.alertWizardBodyMessage2 = data.bodyMessage2;
      this.alertWizardBodyMessage2List = Array.isArray(data.bodyMessage2List)
        ? data.bodyMessage2List
        : [];
      this.cancelButtonText = data.cancelBtnText;
      this.confirmButtonText = data.confirmBtnText;

      this.cancelButtonColor =
        data.cancelButtonColor == undefined
          ? "btn-light-blue"
          : data.cancelButtonColor;
      this.confirmButtonColor =
        data.confirmButtonColor == undefined
          ? "btn-light-red"
          : data.confirmButtonColor;
        this.buttonglobalClass  = data.buttonglobalClass == undefined?"end end":data.buttonglobalClass;
        this.isButtonOneDisabled = data.isButtonOneDisabled == undefined?false:data.isButtonOneDisabled;
        this.isButtonTwoDisabled = data.isButtonTwoDisabled == undefined?false:data.isButtonTwoDisabled;
    }

  ngOnInit(): void {
  }
closeDialog(response:boolean, buttonClick:number){
  this.dialogRef.close({event:'close', data:response, buttonClick:buttonClick })
}
}
